import React, { useEffect, useCallback, useState } from 'react';
import SettingsIcon from '@mui/icons-material/Settings';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid'; 
import Typography from '@mui/material/Typography'; 
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux";
import "css/generalSettings.css";
import PropTypes from 'prop-types';
import image1 from "components/photos/sidebars/reason.png"; 
import image2 from "components/photos/sidebars/status.jpeg"; 
 
const data = [ 
  {"id": 1,
  "title": "Text_Type_Reasons",
  "information": "Text_Information_Type_Reasons",
  "borde":"card border-left-danger shadow h-100 py-2",
  "icon":image1,
  "isEnabled":true
 
},{
  "id": 2,
  "title": "Text_Type_Status",
  "information": "Text_Information_Type_Status",
  "borde":"card border-left-success shadow h-100 py-2",
  "icon":image2,
  "isEnabled":true
}]

const GeneralSettings = ({ setShowPrincipalMenu,showModalGeneralSettings, setShowModalGeneralSettings, setIndexShowSettings }) => {

  const {t} = useTranslation(['listDataGeneralSettings']);
  const [inputText, setInputText] = useState("");
  const roles = useSelector((state) => state.loginUser.roles); 
  data[0].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Reasons'))?true:false; 
  data[1].isEnabled=roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Status'))?true:false;
   
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalGeneralSettings) {
        setInputText("")
        setShowPrincipalMenu(true);
        setShowModalGeneralSettings(false);
        setIndexShowSettings(0);
      }
    },
    [ setShowPrincipalMenu,showModalGeneralSettings, setShowModalGeneralSettings, setIndexShowSettings]
  );

  const closeModalModalGeneralSettings = () => {
    setInputText("")
    setShowPrincipalMenu(true);
    setShowModalGeneralSettings(false);
    setIndexShowSettings(0);
  };

  let inputHandler = (e) => {
    //convert input text to lower case
    var lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  };

  const closeModalStore = (id) => {
    setInputText("");
    setIndexShowSettings(id);
    setShowModalGeneralSettings(false);
  };

  const filteredData = data.filter((el) => {
      if (inputText === '') {
          return el;
      }
      else {
          let dataTranslate=t(el.text);
          return dataTranslate.toLowerCase().includes(inputText);
      }
  })

  const listData= (
    <>
      {filteredData.map((post) => (
        post.isEnabled &&          
            <Grid item xs={2} sm={2} md={2} key={post.id}>
              <div className="card"  style={{width: 200, height:350}}>   
                <div className="card-header p-0">
                  <img src={post.icon} alt={post.title} style={{width: 198, height:120}}/>   
                </div>
                <div className="card-body align-middle"> 
                  <Typography className='text-center text-dark' gutterBottom variant="h6" component="div">
                    {t(post.title)}
                  </Typography>
                  <Typography className='text-justify' variant="body2" color="text.secondary">
                    {t(post.information)}
                  </Typography>
                  
                </div>
                <div className="card-footer">
                  <Button size="small" variant="contained" color="primary" onClick={(e) => closeModalStore(post.id)}>{t('Text_Select')}</Button>
                </div>
              </div>

              
         
        </Grid>
      ))}
    </>    
  );
 
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  return (
    <> 
      {showModalGeneralSettings ? (     
        //* Begin Page Content *//
        <div className="container-fluid">

          {/* Search input */}
          <div id="myDIV">
          <h1 className="h1NewStyle mb-2"><SettingsIcon style={{color:"#ffc107", fontSize:56 }} /> {t('Text_Settings')}</h1>
              <div>
                <button type="button" className="buttonBack" onClick={closeModalModalGeneralSettings}>{t('Button_Back')}</button>
              </div>
          </div>  
          <br/>
          <div className="searchStyle">
            <TextField
              id="outlined-basic"
              variant="outlined"
              value={inputText}
              inputProps={{ style: {fontSize: '18px'} }}
              InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
              placeholder={t('Text_Search')} 
              onChange={inputHandler}
              fullWidth
              label={t('Text_Search')}>
            </TextField>
          </div>
          <br/>
          {/* Content Row */}
          <Grid
            container
            spacing={2}
            columns={12}
            justify="center"
          >
            {listData}
          </Grid>
          {/* End Content Row */}
        </div>  
        //* End Page Content *//
      ) :  null }
    </>
  );
};

GeneralSettings.propTypes = {
  setShowPrincipalMenu: PropTypes.func.isRequired,
  showModalGeneralSettings: PropTypes.bool.isRequired,
  setShowModalGeneralSettings: PropTypes.func.isRequired,
  setIndexShowSettings: PropTypes.func.isRequired,
};

export default GeneralSettings;